import {FuseNavigation} from '@fuse/types';
export const navigation: FuseNavigation[] = [];
